import { logout } from "./logout";
const auth_token_key = "auth_token";

const user_type_key = "user_type";
const company_admin_type_key = "company_admin_type";

export const getUserType = (): string => {
  const sessionType = sessionStorage.getItem(company_admin_type_key) || false;
  if (sessionType) {
    return sessionType;
  }
  const userType = localStorage.getItem(user_type_key) || false;

  if (userType) {
    return userType;
  }
  return "";
};
export const handleLogout = async () => {
  const sessionToken = sessionStorage.getItem(auth_token_key) || false;
  if (sessionToken) {
    sessionStorage.clear();
    await logout(sessionToken);
    return;
  }
  const token = localStorage.getItem(auth_token_key) || false;
  if (token) {
    localStorage.clear();
    await logout(token);
    return;
  }
};
export const setUserAuthTokenInLocalStorage = (token: string) => {
  localStorage.setItem(auth_token_key, token);
};
export const setUserAuthTokenInSessionStorage = (token: string) => {
  sessionStorage.setItem(auth_token_key, token);
};
export const getUserAuthToken = (): string => {
  const sessionAuthToken = sessionStorage.getItem(auth_token_key) || false;
  if (sessionAuthToken) {
    return sessionAuthToken;
  }
  const auth_token = localStorage.getItem(auth_token_key) || false;

  if (auth_token) {
    return auth_token;
  }
  return "";
};

export const setUserTypeInLocalStorage = (type: string) => {
  localStorage.setItem(user_type_key, type);
};
export const setUserTypeInSessionStorage = (type: string) => {
  sessionStorage.setItem(company_admin_type_key, type);
};
